import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Crown, Lock, Check, Clock } from "lucide-react";

export function trialDaysLeft(user) {
  const end = user?.subscription?.trial_ends;
  if (!end) return 0;
  const ms = new Date(end).getTime() - Date.now();
  return Math.max(0, Math.ceil(ms / 86400000));
}

export function ProBadge({ className = "" }) {
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-bold bg-gradient-to-r from-amber-400 to-orange-500 text-white ${className}`} data-testid="pro-badge">
      <Crown className="h-3 w-3" /> PRO
    </span>
  );
}

export function TrialBadge({ user, className = "" }) {
  const navigate = useNavigate();
  const days = trialDaysLeft(user);
  return (
    <button
      onClick={() => navigate("/pricing")}
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[11px] font-bold bg-gradient-to-r from-emerald-500 to-emerald-700 text-white hover:opacity-90 transition ${className}`}
      data-testid="trial-badge"
    >
      <Clock className="h-3 w-3" /> PRO TRIAL · {days}d
    </button>
  );
}

export function UpgradeButton({ className = "" }) {
  const navigate = useNavigate();
  return (
    <Button
      onClick={() => navigate("/pricing")}
      className={`bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 text-white rounded-xl ${className}`}
      data-testid="upgrade-button"
    >
      <Crown className="h-4 w-4 mr-1.5" /> Upgrade
    </Button>
  );
}

export function PremiumLock({ title = "A Sprout Pro feature", description, features = [] }) {
  const navigate = useNavigate();
  return (
    <div className="bg-card rounded-2xl border border-border p-8 sm:p-12 text-center shadow-sm animate-rise" data-testid="premium-lock">
      <div className="h-16 w-16 rounded-2xl bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center mx-auto mb-4 shadow-sm">
        <Lock className="h-8 w-8 text-white" />
      </div>
      <h2 className="font-display text-2xl font-bold">{title}</h2>
      {description && <p className="text-muted-foreground mt-2 max-w-md mx-auto">{description}</p>}
      {features.length > 0 && (
        <ul className="mt-5 inline-flex flex-col gap-2 text-left">
          {features.map((f) => (
            <li key={f} className="flex items-center gap-2 text-sm">
              <Check className="h-4 w-4 text-emerald-600 shrink-0" /> {f}
            </li>
          ))}
        </ul>
      )}
      <div className="mt-6">
        <Button onClick={() => navigate("/pricing")} className="bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 text-white rounded-xl px-6" data-testid="premium-lock-upgrade">
          <Crown className="h-4 w-4 mr-1.5" /> Upgrade to Sprout Pro
        </Button>
      </div>
    </div>
  );
}
